export default __webpack_public_path__ + "static/media/blume4.3179bbdb.png";